import React, { lazy, Suspense, useCallback, useEffect } from "react"
import { retryImport } from "./retryImport"
import { ErrorBoundary } from "react-error-boundary"
import { Button } from "antd"

const MAX_RETRY = 1
const msgErrors = ["Failed to fetch dynamically imported module", "Loading chunk"]

export default function loader({
    factory: importFunc,
    name: displayName = "LazyComponent",
    retry = true
}) {
    const LazyComponent = lazy(() => retryImport(importFunc))
    const ssKey = `reload_count[${displayName}]`

    const EnchantedLazyComponent = (props) => {
        useEffect(() => {
            if (!retry) return
            const count = parseInt(sessionStorage.getItem(ssKey) || 0)
            if (count >= MAX_RETRY) {
                console.log("component load successfully")
                sessionStorage.removeItem(ssKey)
            }
        }, [])
        return <LazyComponent {...props} />
    }

    const FallbackComponent = ({ error }) => {
        const count = parseInt(sessionStorage.getItem(ssKey) || 0)

        if (!retry) throw error
        if (!msgErrors.some((text) => error?.message?.includes(text))) throw error
        if (count >= MAX_RETRY) throw error

        const reload = useCallback(() => {
            sessionStorage.setItem(ssKey, count + 1)
            window.location.reload()
        }, [])

        useEffect(() => {
            setTimeout(reload, 1500)
        }, [])

        return (
            <div style={{ textAlign: "center", padding: "1rem" }}>
                <p>An error occurred. Reloading...</p>
                <Button onClick={() => reload()}>Refresh Now</Button>
            </div>
        )
    }

    const Wrapped = (props) => {
        return (
            <ErrorBoundary
                FallbackComponent={FallbackComponent}
                onError={(error) => console.error("Error loading lazy component:", error)}
            >
                <Suspense fallback={<div />}>
                    <EnchantedLazyComponent {...props} />
                </Suspense>
            </ErrorBoundary>
        )
    }

    Wrapped.displayName = displayName
    return Wrapped
}
